import React, { FC, useContext, useEffect, useState } from 'react'
import ModalWithImage from 'components/modals/ModalWithImage'
import { getLiff, redirectToChatScreen } from 'helpers/liff'
import { AppContext } from 'contexts/AppProvider'
import { useTranslation } from 'react-i18next'

interface ModalPaymentSuccessProps {
  isOpen: boolean
  isLoading: boolean
  lang: string
  onCloseModal: () => void
}

const checkImg = `${process.env.PUBLIC_URL}/assets/generic/modal/check.png`
const liff = getLiff()

const ModalPaymentSuccess: FC<ModalPaymentSuccessProps> = ({ isOpen, isLoading, lang, onCloseModal }) => {
  const { brand } = useContext(AppContext)
  const { t } = useTranslation()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [buttonText, setButtonText] = useState('')

  useEffect(() => {
    if (liff.isInClient()) {
      setTitle(t('dineinPaymentSuccess'))
      setDescription(t('dineinPaymentSuccessDescLiff'))
      setButtonText(t('dineinSeeInvoice'))
    } else {
      setTitle(t('dineinPaymentSuccess'))
      setDescription(t('dineinPaymentSuccessDescBrowser'))
      setButtonText(t('dineInSuccess'))
    }
  }, [lang])

  const onRequestClose = () => {
    if (liff.isInClient()) {
      redirectToChatScreen(brand?.liffID.lineID)
    } else {
      onCloseModal()
    }
  }

  return (
    <ModalWithImage
      data-testid="modal-payment-success"
      isOpen={isOpen}
      isLoading={isLoading}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
      buttonText={buttonText}
      title={title}
      description={description}
      imagePath={checkImg}
      isGenerateSrc
      hideCloseButton
    />
  )
}

export default ModalPaymentSuccess
